import { render, staticRenderFns } from "./tContractors.vue?vue&type=template&id=1c50421c&scoped=true"
import script from "./tContractors.vue?vue&type=script&lang=js"
export * from "./tContractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50421c",
  null
  
)

export default component.exports